/** @format */

export interface AddressV3 {
  address: string;
  address2?: string;
  avsChecked?: boolean;
  city: string;
  country?: string;
  editable?: boolean;
  email?: string;
  external_key?: string;
  first_name: string;
  last_name: string;
  phone?: string;
  preloaded?: boolean;
  state: string;
  zipcode: string;
}
